import React from "react";
import { INVOICE_FE_DISABLED_STATUSES } from "../../../models/Entities";
import {
  BILLING_PATH,
  NOTIFICATIONS_SETTINGS_PATH,
  ORGANIZATION_PATH,
  PROFILE_PATH,
  AUDIT_TRAIL_PATH,
} from "../../../router/RouterUtils";
import useAppContext from "../../context/useAppContext";
import { OrganizationInviteAlert } from "../../shared/banners/OrganizationInviteAlert";
import PortalPageHeaderWrapper from "../../portal/PortalPageHeaderWrapper";
import compact from "lodash/compact";

type Props = {
  title?: string;
  children: JSX.Element | JSX.Element[];
};

function SettingsPage(props: Props) {
  // hooks
  const { user } = useAppContext();

  const dashboardDisabled =
    user.organization.invoice_overdue_status &&
    INVOICE_FE_DISABLED_STATUSES.includes(user.organization.invoice_overdue_status);

  return (
    <PortalPageHeaderWrapper
      title={props.title ?? "Settings"}
      subtabs={compact([
        {
          label: "Profile",
          destination: PROFILE_PATH,
          disabled: dashboardDisabled,
        },
        {
          label: "Organization",
          destination: ORGANIZATION_PATH,
          disabled: dashboardDisabled,
        },
        {
          label: "Audit trail",
          destination: AUDIT_TRAIL_PATH,
          disabled: dashboardDisabled,
        },
        {
          label: "Billing",
          destination: BILLING_PATH,
        },
        {
          label: "Notifications",
          destination: NOTIFICATIONS_SETTINGS_PATH,
          disabled: dashboardDisabled,
        },
      ])}
    >
      <>
        <OrganizationInviteAlert />
        {props.children}
      </>
    </PortalPageHeaderWrapper>
  );
}

export default SettingsPage;
